"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : INFO : STYLES --------------- ++++++++++ */


var _default = {
  info: {
    display: 'block',
    color: _index.theme.color.neutral.medium.swatch,
    fontSize: (0, _index.pxToEm)(12),
    marginTop: (0, _index.pxToEm)(5)
  }
};
exports.default = _default;